import axiosImport from 'axios'
import axios from 'axios'
import Md5 from 'js-md5'
import configs from '../commons/Config'
import userStore from '../commons/UserStore'

axiosImport.defaults.baseURL = (process.env.NODE_ENV === 'development') ? '/api' : configs.serverUrl;

const $http2 = axios.create({
    baseURL: (process.env.NODE_ENV === 'development') ? '/niubi' : configs.serverUrl2,
    timeout: 30000
})

$http2.interceptors.request.use(
    (config) => {
        const user = userStore.getUser()
        const token = user && (user.token || user.Token)
        if (token) {
            config.headers.Authorization = token
        }
        // 安全验证
        let time = new Date().getTime()
        let aesToken = Md5(configs.costkey + time)
        config.headers.calltime = time
        config.headers.token = aesToken
        return config
    },
    (error) => Promise.reject(error)
)

export default {
    $http: axiosImport,
    $http2
}



// WEBPACK FOOTER //
// ./src/api/index.js